import { Duration, Moment } from 'moment';

export const calculateStart = (day: Moment, time: Duration) =>
  day
    .clone()
    .startOf('day')
    .add(time);
